import { DotsSixVertical, Trash } from "@phosphor-icons/react";

import { Button } from "@/components/ui/button";

export const MediaOrganizerGrid = ({
  dataTestId,
  items,
  onMove,
  onPositionChange,
  onRemove,
  paragraphOptions = [],
  showParagraphSelect = false,
  title,
}) => {
  if (!items.length) {
    return null;
  }

  const handleDragStart = (event, itemId) => {
    event.dataTransfer.setData("text/plain", itemId);
    event.dataTransfer.effectAllowed = "move";
  };

  const handleDrop = (event, targetId) => {
    event.preventDefault();
    const sourceId = event.dataTransfer.getData("text/plain");
    if (!sourceId || sourceId === targetId) {
      return;
    }
    onMove(sourceId, targetId);
  };

  return (
    <div className="space-y-3" data-testid={dataTestId}>
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">{title}</p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {items.map((item, index) => (
          <div
            key={item.id}
            className="border border-[rgba(10,15,26,0.12)] bg-white p-3"
            data-testid={`${dataTestId}-item-${index}`}
            draggable
            onDragOver={(event) => event.preventDefault()}
            onDragStart={(event) => handleDragStart(event, item.id)}
            onDrop={(event) => handleDrop(event, item.id)}
          >
            <div className="mb-3 flex items-center justify-between gap-3">
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-slate-500">
                <DotsSixVertical size={16} weight="bold" />
                Drag to reorder
              </div>
              <Button className="h-9 rounded-none border border-[rgba(10,15,26,0.12)] bg-transparent px-3 text-xs font-bold uppercase tracking-[0.16em] text-slate-700 hover:bg-slate-950 hover:text-white" data-testid={`${dataTestId}-remove-${index}`} onClick={() => onRemove(item.id)} type="button" variant="ghost">
                <Trash size={14} weight="bold" />
              </Button>
            </div>
            <div className="overflow-hidden border border-[rgba(10,15,26,0.12)] bg-slate-100">
              <div className="aspect-[4/3] w-full">
                <img alt={item.name} className="h-full w-full object-cover" src={item.previewUrl} />
              </div>
            </div>
            <p className="mt-3 text-sm font-semibold text-slate-900">{item.name}</p>
            {showParagraphSelect ? (
              <div className="mt-3">
                <label className="block text-xs font-bold uppercase tracking-[0.16em] text-slate-500" htmlFor={`${dataTestId}-paragraph-${item.id}`}>
                  Place after paragraph
                </label>
                <select
                  className="mt-2 w-full border border-[rgba(10,15,26,0.12)] px-3 py-3 text-sm outline-none focus:border-slate-950"
                  data-testid={`${dataTestId}-paragraph-${index}`}
                  id={`${dataTestId}-paragraph-${item.id}`}
                  onChange={(event) => onPositionChange(item.id, Number(event.target.value))}
                  value={item.insertAfterParagraph || 1}
                >
                  {paragraphOptions.map((value) => (
                    <option key={`${item.id}-${value}`} value={value}>After paragraph {value}</option>
                  ))}
                </select>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};